import React, { useState } from 'react'
import TextFieldUniversal from '../../../../../validate/form/text/TextFieldUniversal'

const SupplyOrderItemLinksField = ({ required, setValidate, setValueForm, forciblyValue, rows = 2 }) => {

	const [value, setValue] = useState('')

  return (
    <TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'Посилання на товар'} 
        placeholder={'Перелік посилань. Кожне з нової строки'}
        validates={{
            isEmpty: true,
        }}
        forciblyValue={forciblyValue}
        required={required}
        multiline
        rows={rows}
    />
  )
}

export default SupplyOrderItemLinksField